var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.004,
    height: 11.004,
    viewBox: "0 0 11.004 11.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M2282.152,1063.832a.9.9,0,0,1-.917-.917c0-.917.917-3.668,5.5-3.668s5.5,2.751,5.5,3.668a.9.9,0,0,1-.917.917Zm4.585-5.5a2.751,2.751,0,1,0-2.751-2.751A2.751,2.751,0,0,0,2286.737,1058.33Z",
    transform: "translate(-2281.235 -1052.828)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic-user.745e8786144f486da2f5e24fa6fde57a.svg";
export { ForwardRef as ReactComponent };